import { CheckResult, type UploadedFileType } from '../../types/files';

/**
 * Есть ли среди вложений хотя бы одно, успешно загружено (можно отправлять в сообщении).
 */
export const hasPassedAttachment = (attachments: UploadedFileType[]): boolean =>
  attachments.some((file) => file.uploadStatus === CheckResult.Passed);
